import styled, { css } from 'styled-components'
import { themeContract } from './TiledSizePickerTile.theme.contract'

const hoverCss = css`
  background-color: ${props => props.theme.color.palette[themeContract[props.theme.channel].button.hover.background]};
  color: ${props => props.theme.color.palette[themeContract[props.theme.channel].button.hover.color]};
`

const Button = styled.button`
  font-size: 15px;
  min-width: 44px;
  min-height: 44px;
  background: transparent;
  border: 1px solid ${props => props.theme.color.monochrome.light};
  padding: 5px 10px;
  border-radius: 3px;
  margin-right: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-appearance: none;
  &:hover {
    ${hoverCss}
  }
  &:focus {
    ${hoverCss}
  }
  ${props =>
    props.active &&
    css`
      color: ${props.theme.color.palette[themeContract[props.theme.channel].button.color]};
      border-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.borderColor]};
      background-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.background]};
      &:hover {
        background-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.background]};
        color: ${props.theme.color.palette[themeContract[props.theme.channel].button.color]};
      }
    `}
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
      color: ${props.theme.color.monochrome.light};
      background-color: ${props.theme.color.monochrome.lighter};
      border: 1px solid ${props.theme.color.monochrome.light};
      &:hover {
        background-color: ${props.theme.color.monochrome.lighter};
        color: ${props.theme.color.monochrome.light};
      }
    `}
`

export { Button } // eslint-disable-line
